export { default } from './ListSubheader';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/ListSubheader/index.js
// module id = 334
// module chunks = 0